import React from "react";
import { Button, Box, Typography, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ReportIcon from '@mui/icons-material/Report';

const LabReport = ({ name, index_name, analytics_panel_id }) => {
    const [openGrafana, setOpenGrafana] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const timeoutRef = React.useRef(null);

    const handleOpenGrafana = () => {
        setOpenGrafana(true);
        setLoading(true);
        setError(false);
        
        // Set timeout for unresponsive iframe (10 seconds)
        timeoutRef.current = setTimeout(() => {
            if (loading) {
                setError(true);
                setLoading(false);
            }
        }, 10000);
    };

    const handleCloseGrafana = () => {
        setOpenGrafana(false);
        clearTimeout(timeoutRef.current);
    };

    const handleIframeLoad = () => {
        clearTimeout(timeoutRef.current);
        setLoading(false);
    };

    const handleIframeError = () => {
        clearTimeout(timeoutRef.current);
        setError(true);
        setLoading(false);
    };

    const grafanapanelurl = `${process.env.REACT_APP_GRAFANA_URL}/d/${analytics_panel_id}?orgId=1&kiosk`;

    return (
        <>
            <Tooltip title="Overall Lab Report" arrow>
                <span>
                    <Button
                        onClick={handleOpenGrafana}
                        variant="contained"
                        color="primary"
                        aria-label="View lab report"
                        sx={{
                            mx: 0.5,
                            height: { xs: "26px", sm: "30px" },
                            width: { xs: "26px", sm: "30px" },
                            minWidth: 'auto',
                            marginBottom: { xs: "3px", sm: "5px" },
                            marginTop: { xs: "-18px", sm: "-20px" },
                            borderRadius: '50px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            p: 0
                        }}
                    >
                        <ReportIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </Button>
                </span>
            </Tooltip>
            
            <Dialog
                open={openGrafana}
                onClose={handleCloseGrafana}
                aria-labelledby="lab-report-dialog"
                maxWidth='lg'
                fullWidth
            >
                <DialogTitle id="lab-report-dialog">
                    {`ServerName: ${name || 'Not Available'}`}
                </DialogTitle>
                
                <DialogContent>
                    <Box sx={{ minHeight: '500px' }}>
                        {loading && !error && (
                            <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                                <Typography>Loading lab report...</Typography>
                            </Box>
                        )}
                        
                        {error ? (
                            <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                                <Typography color="error">
                                    Report not available at this time. Please try again later.
                                </Typography>
                            </Box>
                        ) : (
                            <iframe 
                                src={grafanapanelurl}
                                width="100%"
                                height="500"
                                frameBorder="0"
                                onLoad={handleIframeLoad}
                                onError={handleIframeError}
                                style={{ display: loading ? 'none' : 'block' }}
                                title="Lab Report"
                            />
                        )}
                    </Box>
                </DialogContent>
                
                <DialogActions>
                    <Tooltip title="Close" arrow>
                        <Button onClick={handleCloseGrafana} color="primary" autoFocus>
                            Close
                        </Button>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LabReport;